import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost/securecontrol-backend";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  // Couleurs SecureControl
  const primaryColor = "#0B3C5D"; // Bleu Sécurité
  const primaryHover = "#1E88C8"; // Bleu Tech (hover)
  const accentColor = "#4FC3F7"; // Bleu Clair
  const bgColor = "#F5F7FA"; // Gris Clair (fond)
  const textColor = "#2E2E2E"; // Gris Foncé (texte)
  const borderColor = "#e0e0e0"; // Bordure légère

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    if (!email.trim()) {
      setError("Veuillez saisir votre adresse email.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/reset_password.php`,
        { email: email.trim() },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success) {
        setSuccess(true);
        setMessage(response.data.message || "Un email avec un lien de réinitialisation vous a été envoyé.");
      } else {
        setError(response.data?.message || "Une erreur s'est produite.");
      }
    } catch (err) {
      console.error("Erreur:", err);
      
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err.code === 'ERR_NETWORK') {
        setError("Erreur réseau. Vérifiez votre connexion.");
      } else {
        setError("Une erreur s'est produite. Veuillez réessayer.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      backgroundColor: bgColor, 
      height: '100vh',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Inter', sans-serif",
      overflow: 'hidden',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }}>
      <div style={{
        width: '100%',
        maxWidth: '450px',
        padding: '20px',
        transform: 'scale(0.9)',
        transformOrigin: 'center center'
      }}>
        {/* Header avec logo */}
        <div className="text-center mb-4">
          <div className="mb-4">
           <img 
  src="/assets/img/secureLogo.png" 
  alt="SecureControle Logo" 
  className="mb-3"
  style={{ 
    width: '70px',
    height: '70px',
    borderRadius: '18px'
  }}
/>
            <h1 style={{ 
              color: primaryColor,
              fontWeight: '700',
              fontSize: '1.8rem',
              marginBottom: '6px',
              lineHeight: '1.2'
            }}>
              SecureControle
            </h1>
            <p style={{ 
              color: textColor,
              fontSize: '0.9rem',
              opacity: 0.8,
              marginBottom: '0'
            }}>
              Plateforme de gestion de sécurité
            </p>
          </div>
        </div>

        {/* Carte principale */}
        <div className="card mb-4" style={{ 
          backgroundColor: 'white',
          border: `1px solid ${borderColor}`,
          borderRadius: '14px',
          boxShadow: '0 6px 24px rgba(11, 60, 93, 0.1)',
          width: '100%',
          overflow: 'hidden'
        }}>
          <div className="card-body p-4">
            <div className="text-center mb-4">
              <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ 
                width: '50px',
                height: '50px',
                backgroundColor: '#E3F2FD',
                color: primaryColor
              }}>
                <i className="bi bi-key fs-5"></i>
              </div>
              <h5 style={{ 
                color: primaryColor,
                fontWeight: '600',
                marginBottom: '6px',
                fontSize: '1.1rem'
              }}>
                <i className="bi bi-key me-2" style={{ color: accentColor, fontSize: '1rem' }}></i>
                Mot de passe oublié
              </h5>
              <p style={{ 
                color: textColor,
                opacity: 0.7,
                fontSize: '0.85rem',
                marginBottom: '0'
              }}>
                Entrez votre adresse email pour recevoir un lien de réinitialisation
              </p>
            </div>

            {error && (
              <div className="alert alert-danger alert-dismissible fade show mb-4" style={{ 
                backgroundColor: '#ffebee',
                borderColor: '#f44336',
                color: '#c62828',
                borderRadius: '8px',
                borderLeft: '4px solid #f44336',
                padding: '12px',
                fontSize: '0.85rem',
                marginBottom: '20px'
              }}>
                <div className="d-flex align-items-center">
                  <i className="bi bi-exclamation-triangle me-2" style={{ fontSize: '1rem' }}></i>
                  <div className="flex-grow-1">{error}</div>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setError("")}
                    style={{ fontSize: '0.75rem' }}
                  ></button>
                </div>
              </div>
            )}

            {message && success && (
              <div className="alert alert-success alert-dismissible fade show mb-4" style={{ 
                backgroundColor: '#e8f5e9',
                borderColor: '#4caf50',
                color: '#2e7d32',
                borderRadius: '8px',
                borderLeft: '4px solid #4caf50',
                padding: '12px',
                fontSize: '0.85rem',
                marginBottom: '20px'
              }}>
                <div className="d-flex align-items-center">
                  <i className="bi bi-check-circle me-2" style={{ fontSize: '1rem' }}></i>
                  <div className="flex-grow-1">{message}</div>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setMessage("")}
                    style={{ fontSize: '0.75rem' }}
                  ></button>
                </div>
              </div>
            )}

            {!success ? (
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label htmlFor="email" className="form-label" style={{ 
                    color: textColor,
                    fontWeight: '500',
                    fontSize: '0.85rem',
                    marginBottom: '6px',
                    display: 'block'
                  }}>
                    <i className="bi bi-envelope me-1" style={{ color: accentColor, fontSize: '0.9rem' }}></i>
                    Adresse email
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" style={{ 
                      backgroundColor: bgColor,
                      borderColor: borderColor,
                      color: accentColor,
                      borderRight: 'none',
                      borderRadius: '8px 0 0 8px',
                      padding: '10px 12px',
                      fontSize: '0.9rem'
                    }}>
                      <i className="bi bi-person"></i>
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="votre@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                      style={{ 
                        borderColor: borderColor,
                        borderRadius: '0 8px 8px 0',
                        color: textColor,
                        padding: '10px 12px',
                        fontSize: '0.9rem',
                        height: '44px'
                      }}
                    />
                  </div>
                </div>

                <div className="d-grid mb-4">
                  <button
                    type="submit"
                    className="btn fw-semibold"
                    disabled={loading}
                    style={{
                      backgroundColor: loading ? '#B0BEC5' : primaryColor,
                      borderColor: loading ? '#B0BEC5' : primaryColor,
                      color: 'white',
                      padding: '12px',
                      borderRadius: '8px',
                      fontSize: '0.95rem',
                      transition: 'all 0.3s ease',
                      opacity: loading ? 0.8 : 1,
                      height: '48px'
                    }}
                    onMouseEnter={(e) => {
                      if (!loading) {
                        e.target.style.backgroundColor = primaryHover;
                        e.target.style.borderColor = primaryHover;
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 8px rgba(11, 60, 93, 0.2)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!loading) {
                        e.target.style.backgroundColor = primaryColor;
                        e.target.style.borderColor = primaryColor;
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }
                    }}
                    onMouseDown={(e) => {
                      if (!loading) {
                        e.target.style.transform = 'translateY(0)';
                      }
                    }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" style={{ width: '1rem', height: '1rem' }}></span>
                        Envoi en cours...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-send me-2"></i>
                        Envoyer le lien de réinitialisation
                      </>
                    )}
                  </button>
                </div>

                {/* Ligne séparatrice */}
                <div className="position-relative text-center my-4">
                  <hr style={{ 
                    borderColor: borderColor, 
                    opacity: 0.5,
                    margin: '20px 0'
                  }} />
                  <span style={{ 
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '0 12px',
                    color: textColor,
                    fontSize: '0.8rem',
                    opacity: 0.7,
                    whiteSpace: 'nowrap'
                  }}>
                    Ou
                  </span>
                </div>

                {/* Lien retour connexion */}
                <div className="text-center">
                  <Link 
                    to="/login" 
                    className="btn fw-semibold"
                    style={{
                      color: primaryColor,
                      border: `1px solid ${primaryColor}`,
                      backgroundColor: 'transparent',
                      padding: '10px',
                      borderRadius: '8px',
                      fontSize: '0.9rem',
                      width: '100%',
                      transition: 'all 0.3s ease',
                      height: '44px'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = primaryColor;
                      e.target.style.color = 'white';
                      e.target.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = primaryColor;
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Retour à la connexion
                  </Link>
                </div>
              </form>
            ) : (
              <div className="text-center">
                <div className="mb-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ 
                    width: '70px',
                    height: '70px',
                    backgroundColor: '#e8f5e9',
                    color: '#4caf50',
                    fontSize: '1.8rem',
                    boxShadow: '0 4px 12px rgba(76, 175, 80, 0.2)'
                  }}>
                    <i className="bi bi-envelope-check"></i>
                  </div>
                  <h5 className="mt-3" style={{ 
                    color: '#2e7d32',
                    fontSize: '1.1rem',
                    marginBottom: '8px'
                  }}>Email envoyé !</h5>
                  <p style={{ 
                    color: textColor,
                    opacity: 0.8,
                    fontSize: '0.9rem',
                    maxWidth: '350px',
                    margin: '0 auto 16px'
                  }}>
                    Vérifiez votre boîte de réception et suivez les instructions.
                  </p>
                  <div className="alert alert-info border-info" style={{ 
                    backgroundColor: '#E3F2FD',
                    borderColor: accentColor,
                    color: primaryColor,
                    borderRadius: '8px',
                    maxWidth: '350px',
                    margin: '0 auto',
                    padding: '10px',
                    fontSize: '0.8rem'
                  }}>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-info-circle me-2" style={{ color: accentColor, fontSize: '0.9rem' }}></i>
                      <small>
                        Si vous ne recevez pas l'email, vérifiez vos spams ou réessayez.
                      </small>
                    </div>
                  </div>
                </div>
                
                <div className="d-grid gap-3" style={{ gap: '12px' }}>
                  <button
                    onClick={() => navigate("/login")}
                    className="btn fw-semibold"
                    style={{
                      backgroundColor: primaryColor,
                      borderColor: primaryColor,
                      color: 'white',
                      padding: '12px',
                      borderRadius: '8px',
                      fontSize: '0.95rem',
                      transition: 'all 0.3s ease',
                      height: '48px'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = primaryHover;
                      e.target.style.borderColor = primaryHover;
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 8px rgba(11, 60, 93, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = primaryColor;
                      e.target.style.borderColor = primaryColor;
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <i className="bi bi-box-arrow-in-right me-2"></i>
                    Retour à la connexion
                  </button>
                  
                  <button
                    onClick={() => {
                      setSuccess(false);
                      setEmail("");
                    }}
                    className="btn fw-semibold"
                    style={{
                      color: primaryColor,
                      border: `1px solid ${primaryColor}`,
                      backgroundColor: 'transparent',
                      padding: '10px',
                      borderRadius: '8px',
                      fontSize: '0.9rem',
                      transition: 'all 0.3s ease',
                      height: '44px'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = primaryColor;
                      e.target.style.color = 'white';
                      e.target.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = primaryColor;
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    <i className="bi bi-arrow-clockwise me-2"></i>
                    Essayer avec un autre email
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-3" style={{ width: '100%' }}>
          <div style={{ 
            color: textColor,
            opacity: 0.6,
            fontSize: '0.8rem',
            lineHeight: '1.4'
          }}>
            <div className="mb-1">
              <i className="bi bi-shield-check me-1" style={{ color: primaryColor, fontSize: '0.9rem' }}></i>
              <strong style={{ color: primaryColor }}>Sécurité garantie</strong> • 
              <span className="mx-1">•</span>
              <i className="bi bi-cloud-check me-1" style={{ color: accentColor, fontSize: '0.9rem' }}></i>
              <span>Service cloud</span>
            </div>
            <p className="mb-0" style={{ fontSize: '0.8rem' }}>
              © {new Date().getFullYear()} SecureControle. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>

      {/* Styles CSS additionnels */}
      <style>{`
        * {
          font-family: 'Inter', sans-serif;
          box-sizing: border-box;
        }
        
        body, html {
          margin: 0;
          padding: 0;
          overflow: hidden !important;
          height: 100%;
          width: 100%;
          position: fixed;
        }
        
        #root {
          height: 100vh;
          width: 100vw;
          overflow: hidden;
        }
        
        .form-control:focus {
          border-color: ${accentColor};
          box-shadow: 0 0 0 0.2rem rgba(79, 195, 247, 0.25);
          outline: none;
        }
        
        a:hover {
          text-decoration: none;
        }
        
        /* Media Queries pour l'adaptabilité */
        @media (max-width: 768px) {
          div[style*="transform: scale(0.9)"] {
            transform: scale(0.95) !important;
            padding: 16px !important;
          }
          
          .card {
            margin: 0 auto;
            border-radius: 12px !important;
          }
        }
        
        @media (max-width: 576px) {
          div[style*="transform: scale(0.9)"] {
            transform: scale(1) !important;
            padding: 12px !important;
          }
          
          .card-body {
            padding: 20px !important;
          }
          
          .btn {
            padding: 10px !important;
            font-size: 0.9rem !important;
          }
          
          h1 {
            font-size: 1.6rem !important;
          }
          
          .logo-container {
            width: 60px !important;
            height: 60px !important;
            font-size: 1.8rem !important;
          }
        }
        
        @media (max-height: 700px) {
          div[style*="transform: scale(0.9)"] {
            transform: scale(0.85) !important;
          }
          
          .mb-4 {
            margin-bottom: 1rem !important;
          }
          
          .card-body {
            padding: 20px !important;
          }
        }
        
        @media (max-height: 600px) {
          div[style*="transform: scale(0.9)"] {
            transform: scale(0.8) !important;
          }
          
          .card {
            margin-bottom: 10px !important;
          }
          
          .text-center.mb-4 {
            margin-bottom: 1.5rem !important;
          }
        }
        
        @media (max-height: 500px) {
          div[style*="transform: scale(0.9)"] {
            transform: scale(0.75) !important;
          }
        }
        
        /* Pour les très petits écrans */
        @media (max-width: 375px) {
          div[style*="transform: scale(0.9)"] {
            transform: scale(0.95) !important;
          }
          
          .card-body {
            padding: 16px !important;
          }
          
          .input-group-text, .form-control {
            padding: 8px 10px !important;
            font-size: 0.85rem !important;
          }
        }
        
        /* Assure que rien ne dépasse */
        .card, .text-center, form {
          max-width: 100%;
        }
      `}</style>
    </div>
  );
};

export default ForgotPassword;